<template>
  <div class="settings-page">
    <block-buttons
      title="Настройки сайта"
      description="Управление настройками сайта"
      :actions="toolbarActions"
    >
      <template #icon>
        <GalleryVerticalEnd :size="22" />
      </template>
    </block-buttons>

    <data-table
      :rows="renderData"
      :columns="tableColumns"
      :loading="loading"
      :error="error"
      title="Настройки сайта"
      description="Просмотр и управление настроек"
      search-placeholder="Поиск по настройкам"
      empty-text="Список настроек пуст"
      @retry="loadDataWrapper(true)"
    >
      <template #cell-actions="{ row }">
        <select
          :disabled="loading"
          :aria-label="`Действия с настройкой ${row.title}`"
          @change="selectAction($event, row)"
        >
          <option value="">Действия</option>

          <option
            v-for="action in rowActions"
            :key="action.id"
            :value="action.id"
          >
            {{ action.label }}
          </option>
        </select>
      </template>
    </data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import {
  GalleryVerticalEnd,
  RefreshCw
} from 'lucide-vue'

import BlockButtons from '@/components/blockButtons'
import DataTable from '@/components/dataTable'

export default {
  name: 'settingsV2',
  components: {
    GalleryVerticalEnd,
    BlockButtons,
    DataTable
  },
  data () {
    return {
      loading: false,
      error: ''
    }
  },
  computed: {
    // ...mapGetters('settings', ['getData']),
    ...mapGetters('settings', ['getTableColumns', 'getDefaultValues']),
    renderData () {
      // return this.getData.map(order => ({
      //   ...order,
      //   status: this.getDefaultValues?.['settings']?.find(({ code }) => code === order.status)?.name || order.status || '—'
      // }))

      return []
    },
    toolbarActions () {
      return  [
        {
          id: 'refresh',
          label: 'Обновить',
          icon: RefreshCw,
          disabled: this.loading,
          handler: this.loadDataWrapper
        }
      ]
    },
    tableColumns () {
      return [
        {
          key: 'actions',
          label: 'Действия',
          sortable: false
        },
        ...(this.getTableColumns?.['settings'] || [])
      ]
    },
    rowActions () {
      return [
        {
          id: 'info',
          label: 'Информация',
          visible: true
        }
      ]
    }
  },
  mounted () {
    this.loadDataWrapper()
  },
  methods: {
    // ...mapActions('settings', ['loadData']),
    ...mapActions('modal', ['openModal']),
    async loadDataWrapper () {
      if (this.loading) {
        return
      }

      this.$bus.emit('start-loader')
      this.loading = true

      // await this.loadData()

      this.loading = false
      this.$bus.emit('stop-loader')
    },
    selectAction (event, row) {
      const action = event.target.value

      event.target.value = ''

      if (!action) {
        return
      }

      this.openAction(action, row)
    },
    openAction (action, row) {
      switch (action) {
        case 'info':
          this.openModal({
            name: 'info-base',
            propsData: {
              name: 'settings',
              moduleAction: 'settings',
              type: 'info',
              title: `Информация о настройке - ${row.type}`,
              textCancelBtn: 'Закрыть',
              data: row
            }
          })
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
